<template>
    <div class="flow-root my-4">
        <template v-if="files.length > 0">
            <template v-if="hasSpecialDateLayout">
                <ul class="-my-5 divide-y divide-gray-200">
                    <li v-for="group in dateGroupedFiles" :key="group.key">
                        <div class="px-4 py-3 sm:px-6 font-bold text-gray-600 bg-gray-200 cursor-pointer flex justify-between items-center"
                             @click.prevent="toggleYear(group.key)">
                            <span>{{ group.isUndated ? $t('Other') : group.year }}</span>
                            <span>
                                <ChevronDownIcon class="h-5 w-5" aria-hidden="true" v-if="isOpen(group.key)"/>
                                <ChevronUpIcon class="h-5 w-5" aria-hidden="true" v-else/>
                            </span>
                        </div>
                        <Transition enter-from-class="opacity-0"
                                    enter-active-class="transition duration-500">
                            <ul class="ml-3 divide-y divide-gray-200"
                                v-if="isOpen(group.key)">
                                <li class="hover:bg-gray-100"
                                    v-for="entry in group.items" :key="entry.file.hash">
                                    <file-container-file :file="entry.file"
                                                         :display-name="entry.displayName"
                                                         :mutation-disabled="mutationDisabled"></file-container-file>
                                </li>
                            </ul>
                        </Transition>
                    </li>
                </ul>
            </template>
            <template v-else>
                <ul class="-my-5 divide-y divide-gray-200">
                    <li class="hover:bg-gray-100"
                        v-for="file in files" :key="file.hash">
                        <file-container-file :file="file" :mutation-disabled="mutationDisabled"></file-container-file>
                    </li>
                </ul>
            </template>
        </template>
        <template v-else>
            <div class="px-4 py-5 md:px-6 text-center text-info-800 opacity-75">
                {{ $t('There are currently no documents available.') }}
            </div>
        </template>
    </div>
</template>

<script setup>
import {ChevronDownIcon, ChevronUpIcon} from '@heroicons/vue/solid'
</script>

<script>
import FileContainerFile from "@/Components/FileContainerFile";
import {groupFilesByImportDate} from "@/Support/fileDateGrouping";

export default {
    name: "FileContainerContent",
    components: {
        FileContainerFile,
    },
    props: {
        files: Array,
        hasSpecialDateLayout: Boolean,
        mutationDisabled: Boolean,
    },
    computed: {
        dateGroupedFiles() {
            return groupFilesByImportDate(this.files);
        },

        /**
         * The expanded group: the newest one until something is clicked, false once the open group
         * has been collapsed by hand.
         */
        activeYear() {
            if (this.openYear !== null) {
                return this.openYear;
            }

            const [firstGroup] = this.dateGroupedFiles;

            return firstGroup ? firstGroup.key : null;
        },
    },
    data() {
        return {
            // null means untouched, which leaves the newest group open.
            openYear: null,
        };
    },
    methods: {
        toggleYear(key) {
            this.openYear = this.activeYear === key ? false : key;
        },
        isOpen(key) {
            return this.activeYear === key;
        },
    },
}
</script>

<style scoped>

</style>
